import { create } from 'zustand'

export interface PendingScoutOperation {
  scanId: string
  username: string
  customerId: string
  startedAt: number
}

interface ScoutOperationStore {
  pendingOperations: PendingScoutOperation[]
  lastCompletedAt: number | null
  addOperation: (op: PendingScoutOperation) => void
  removeOperation: (scanId: string) => void
  markCompleted: (scanId: string) => void
  clearAll: () => void
}

const useScoutOperationStore = create<ScoutOperationStore>((set) => ({
  pendingOperations: [],
  lastCompletedAt: null,

  addOperation: (op) =>
    set((state) => ({
      pendingOperations: [...state.pendingOperations, op]
    })),

  removeOperation: (scanId) =>
    set((state) => ({
      pendingOperations: state.pendingOperations.filter(
        (op) => op.scanId !== scanId
      )
    })),

  markCompleted: (scanId) =>
    set((state) => ({
      pendingOperations: state.pendingOperations.filter(
        (op) => op.scanId !== scanId
      ),
      lastCompletedAt: Date.now()
    })),

  clearAll: () => set({ pendingOperations: [] })
}))

export default useScoutOperationStore
